export default __webpack_public_path__ + "static/media/BING_HEALTH.ca881013.png";